import React from "react";
import Logo from "./Logo";
import "./Section.css";
import {APKLink, GoogleStoreLink, HuaweiLink, SamsungLink, XiaomiLink} from "./Links";

const SectionRu = () => {
  return (
    <section className="app-section">
      <h1>Как установить Tango: пошаговое руководство</h1>
      <h5>Выйди в прямой эфир. Общайся. Наслаждайся – в любое время, в любом месте!</h5>
      <div className="icon-section">
        <Logo />
        <div className="icon-section__text">
          <span>Автор: Tango</span>
          <span>Обновлено вчера</span>
        </div>
      </div>
      <p>
        <b>
          Tango доступен на разных платформах, что позволяет легко выйти в прямой эфир и наслаждаться развлечениями в любое время и в любом месте.
        </b>
      </p>
      <hr />
      <h2>🤖 Для пользователей Android</h2>
      <p>
        Вы можете скачать Tango напрямую из:
      </p>
      <ul>
        <li>
          <GoogleStoreLink text={"Google Play Store"}/>
        </li>
        <li>
          <XiaomiLink/>
        </li>
        <li>
          <HuaweiLink/>
        </li>
        <li>
          <SamsungLink/>
        </li>
      </ul>
      <hr />
      <br />
      <h2> Для устройств iOS:</h2>
      <p>
        <b>
          Если вы ранее устанавливали Tango на своем устройстве iOS, вы можете повторно загрузить его из App Store.
        </b>
      </p>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/TQkbk0cvsxE?si=e5ZqM_EWiJe9F01R"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        1. Откройте App Store: Зайдите в App Store на своем устройстве iOS.
      </p>
      <p>
        2. Нажмите на изображение своего профиля в правом верхнем углу экрана, чтобы открыть настройки аккаунта.
      </p>
      <p>
        3. Перейдите в раздел "Приложения" или "История покупок": Пролистайте список ранее приобретённых приложений или воспользуйтесь строкой поиска вверху, чтобы найти "Tango".
      </p>
      <p>
        4. Повторно скачайте Tango: Как только вы найдете Tango в списке, нажмите на иконку облака со стрелкой, чтобы скачать приложение.
      </p>
      <p>
        5. Откройте приложение Tango после установки и следуйте процессу регистрации или входа в аккаунт.
      </p>
      <hr />
      <h2>Впервые на Tango? Легко добавьте Tango на главный экран для быстрого доступа</h2>
      <iframe
        width="640"
        height="360"
        src="https://www.youtube.com/embed/iM15aUI94Yo?si=qee02UWPVKEXtDdF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        1. Откройте сайт Tango: Перейдите по ссылке <a href="https://tango.me">https://tango.me</a> в браузере своего мобильного устройства.
      </p>
      <p>
        2. Нажмите на значок "Поделиться": Квадрат со стрелкой вверх внизу экрана.
      </p>
      <p>
        3. Выберите "Добавить на главный экран" в меню, и ярлык Tango будет добавлен на главный экран вашего устройства.
      </p>
      <p>
        После установки вы готовы выходить в прямой эфир, поддерживать любимых авторов и наслаждаться бесконечными развлечениями – всё в ваших руках!
      </p>
      <br/>
      <b>Начните сейчас и присоединяйтесь к действию! 🎉</b>
    </section>
  );
};

export default SectionRu;
